const $sliders = $('.js-slider');

function init() {
	$sliders.each((i, el) => {
		$(el).not('.slick-initialized').slick({
			rows: 0,
			speed: 1000,
			mobileFirst: true,
			adaptiveHeight: true,
			prevArrow: '<button class="slick-arrow slider__button slider__button--prev btn" type="button" title="Предыдущий слайд"><svg><use xlink:href="./images/sprites.svg#arrow"></use></svg></button>',
			nextArrow: '<button class="slick-arrow slider__button slider__button--next btn" type="button" title="Следующий слайд"><svg><use xlink:href="./images/sprites.svg#arrow"></use></svg></button>',
		});
	});
}

function destroy() {
	if ($sliders.hasClass('slick-initialized')) {
		$sliders.slick('destroy');
	}
}

export default {
	init,
	destroy,
};
